const { getParameterByName, loadTiles } = require('./handleFiltering');
/**
 * The stored value from our ajax call (so we only ever need to make one)
 */
let memoizedValue = null;

/**
 * Convert the html returned by the server to a jquery object for filtering later
 * @param {string} tileHtml 
 */
const parseHtmlString = (tileHtml) => $(tileHtml).filter('.tile');

/**
 * A memoized function that will return a jquery object of tiles from the server for the given stream
 */
const getTiles = () => {
    if (memoizedValue) {
        return Promise.resolve(memoizedValue.clone());
    }

    return new Promise((resolve, reject) => {
        const collectionId = $('#page-type-identifier').attr('data-collection-id');
        let hubUrl = '';
      
        const hubId = document.querySelector('meta[name="uberflip:hub_id"]').content;

        if(hubId === '118316') {
            hubUrl = '/it';
        }
        if(hubId === '118319') {
            hubUrl = '/es';
        }
        if(hubId === '118322') {
            hubUrl = '/de';
        }
        if(hubId === '100549') {
            hubUrl = '/fr';
        }
        if(hubId === '132028') {
            hubUrl = '/ja';
        }
    
        
        $.get(
                `${hubUrl}/hubsFront/ajax_loadAdditionalItems/?collectionId=${collectionId}&currentPage=-1&limit=0&featuredItemCount=0&embedded=0&excludeCTAs=true`
            )
            .success((data) => {
                const parsedTiles = parseHtmlString(data);
                memoizedValue = parsedTiles.clone();
                const tileContainer = document.querySelector('#collection-items .collection-items-container');
                // in this sample request, the function will remove any tiles in the
                // stream's tileContainer and replace it with data from our fetch call

                const tiles = [...document.querySelectorAll('#collection-items .tile')];
                if (tiles) {
                    // - Iterate over each tile
                    tiles.forEach((tile) => {
                        tile.remove();
                    });
                }
                tileContainer.insertAdjacentHTML('beforeend', data);
                
                $('#collection-items .collection-items-container').css('display', 'block');
                $('#onBrand__filter-wrapper #onBrand__filter--form').css('display', 'flex'); // Uberflip Outsource OB-10258
                // document.querySelector('#onBrand__filter-wrapper .onBrand__filter--form').style.display = 'flex';
                const moveToTopBtn = document.getElementById('load-more');
                const liTags = document.querySelectorAll('li.tile:not(.cta)');
                if (liTags) {
                    liTags.forEach((tags) => {
                        tags.style.setProperty('display', 'block', 'important');
                        tags.style.setProperty('opacity', '1', 'important');
                    });
                }
                if (moveToTopBtn) {
                    moveToTopBtn.style.display = 'none';
                }
                resolve(parsedTiles.clone());
                if (getParameterByName('filterParams=')) {
                    loadTiles();
                }

            })
            .fail(reject);
    });
};

module.exports = getTiles;


// WEBPACK FOOTER //
// ./scriptPartials/filter/getTiles.js